module.exports = __webpack_public_path__ + "static/media/filled_bar_SMAP.b79fdec4.svg";